import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SimConnectivity from "./components/simConnectivity/simConnectivity";
import SimBilling from "./components/simBilling/simBilling";
import Spinner from "../../components/presentationals/Spinner";
import ActivationDistribution from "./components/distribution/activationSalesDistribution";
import { getPartnerRoleID, isEmptyObject } from "../../utils/common/index";
import {
  triggerShowHeader,
  unsetPayoutDashboard,
} from "../../redux/actions/action";
import { triggerFetchTimeStamp, unsetRun } from "../../redux/actions";
import ActivationSalesView from "../../views/activationSales/activationSalesView";
import CustomLandingBody from "../../components/customLandingBody";
import { triggerIsDashboardAccessible } from "../../redux/actions";

const salesData = (obj) => {
  let {
    getAllAPI,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    timestampArr,
  } = obj;

  if (
    getAllAPI &&
    !isEmptyObject(getAllAPI.data) &&
    getAllAPI.data.content &&
    getAllAPI.data.content[1]
  ) {
    const { data } = getAllAPI;
    const { content: hierarchy } = data;
    const ActivationModuleModel = hierarchy.filter(
      (item) => item.moduleName.toLowerCase() === "sim activation"
    )[0];
    const mdnSimConnectivityModel = hierarchy
      ? hierarchy
          .filter(
            (item) => item.moduleName.toLowerCase() === "sim activation"
          )[0]
          .modSecMasterTxDtos.filter(
            (section) =>
              section.sectionName.toLowerCase() === "mdn sim connectivity"
          )[0]
      : {};
    const simBillingModel = hierarchy
      ? hierarchy
          .filter(
            (item) => item.moduleName.toLowerCase() === "sim activation"
          )[0]
          .modSecMasterTxDtos.filter(
            (section) => section.sectionName.toLowerCase() === "sim billing"
          )[0]
      : {};
    const activationDistributionModel = hierarchy
      ? hierarchy
          .filter(
            (item) => item.moduleName.toLowerCase() === "sim activation"
          )[0]
          .modSecMasterTxDtos.filter(
            (section) => section.sectionName.toLowerCase() === "distribution"
          )[0]
      : {};
    const moduleName = hierarchy
      ? hierarchy.filter(
          (item) => item.moduleName.toLowerCase() === "sim activation"
        )[0].moduleName
      : "";
    return (
      <>
        {ActivationModuleModel?.isModuleActive === "Y" ? (
          <>
            {activationDistributionModel &&
            activationDistributionModel.isSectionActive === "Y" ? (
              <ActivationDistribution
                activationDistributionModel={activationDistributionModel}
                headerSelectedDateFrom={headerSelectedDateFrom}
                headerSelectedDateTo={headerSelectedDateTo}
                filterValue={filterValue}
                moduleName={moduleName}
                timestamp={timestampArr}
              />
            ) : null}
            {simBillingModel && simBillingModel.isSectionActive === "Y" ? (
              <SimBilling
                filterValue={filterValue}
                headerSelectedDateFrom={headerSelectedDateFrom}
                headerSelectedDateTo={headerSelectedDateTo}
                simBillingModel={simBillingModel}
                moduleName={moduleName}
                timestamp={timestampArr}
              />
            ) : null}
            {mdnSimConnectivityModel &&
            mdnSimConnectivityModel.isSectionActive === "Y" ? (
              <SimConnectivity
                componentToRender="SIM Connectivity"
                activationModel={mdnSimConnectivityModel}
                data-cy="sim-connectivity"
                filterValue={filterValue}
                headerSelectedDateFrom={headerSelectedDateFrom}
                headerSelectedDateTo={headerSelectedDateTo}
                moduleName={moduleName}
                timestamp={timestampArr}
              />
            ) : null}
          </>
        ) : null}
      </>
    );
  } else {
    if (getAllAPI && getAllAPI.loading) {
      return <Spinner />;
    } else {
      return (
        <div
          className="whitebox wow fadeInUp"
          data-wow-delay=".6s"
          data-wow-duration="0.7s"
        >
          Unable to fetch data
        </div>
      );
    }
  }
};

const ActivationSales = () => {
  const {
    getAllAPI,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    partnerRoleType,
    timestamp,
    tilesData,
  } = useSelector((state) => state.homeReducer);

  const { dashboardAccessibility } = useSelector(
    (state) => state?.dashboardAccessibilityReducer
  );

  const dispatch = useDispatch();

  const [showAlert, setShowAlert] = useState(null);
  const [dashboardName, setDashboardName] = useState("Sim Activation");

  const moduleName =
    getAllAPI && getAllAPI.data && getAllAPI.data.content
      ? getAllAPI.data.content.filter(
          (item) => item.moduleName.toLowerCase() === "sim activation"
        )[0].moduleName
      : null;
  let timeStampObj = {
    headers: {
      "Content-Type": "application/json",
    },
    params: {
      moduleName: moduleName,
      partnerRole: getPartnerRoleID(filterValue.selectedPartnerRoleName),
    },
  };

  let timestampArr = null;
  if (timestamp && timestamp.data && timestamp.data[moduleName]) {
    timestampArr = timestamp.data[moduleName][moduleName];
  }

  useEffect(() => {
    const showHeader = () => {
      return dispatch(triggerShowHeader(true));
    };

    const unsetPayoutDashboardForCalender = () => {
      return dispatch(unsetPayoutDashboard());
    };
    unsetPayoutDashboardForCalender();

    const fetchTimeStamp = () => {
      return dispatch(triggerFetchTimeStamp(timeStampObj, moduleName));
    };

    //check if isTestingActive is true, then send api call for triggerIsDashboardAccessible
    let isTestingActive = tilesData?.data?.content?.filter(
      (obj) => obj.moduleName === dashboardName
    )[0].isTestingActive;

    //if it is true, then check if this loggedin user has access to this dashboard
    if (isTestingActive) {
      //to check if the response for this dashboard api call is already cached in redux
      let isExistingDashboard = dashboardAccessibility?.data?.filter(
        (currentDashboard) => currentDashboard.dashboard === dashboardName
      );

      //if dashboard accessibility is already cached and accessEnabled is false, means directly show alert without sending api call again
      if (
        isExistingDashboard.length > 0 &&
        !isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        // load dashboardcard home component and show alert
        return setShowAlert(true);
      }

      // if dashboard accessibility is cached and accessEnabled is true, do not send api call, do not show alert BUT SHOW DASHBOARD NORMALLY
      else if (
        isExistingDashboard.length > 0 &&
        isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        setShowAlert(false);

        if (
          getAllAPI &&
          getAllAPI.data &&
          getAllAPI.data.content &&
          getAllAPI.data.content[0]
        ) {
          fetchTimeStamp();
        }
        showHeader();
      }

      //if dashboard accessibility is not cached already then send api call for this dashboard
      else {
        const data = {
          baseParameter: {
            name: dashboardName,
            userType: filterValue.site,
          },
          domainId:
            filterValue.orgId !== "" ? filterValue.orgId : filterValue?.agentId,
        };

        const obj = {
          headers: {
            "Content-Type": "application/json",
            url: "get-dashboard-user-role-mapping",
          },
          params: data,
          extraData: "get-dashboard-user-role-mapping",
        };

        return dispatch(
          triggerIsDashboardAccessible(obj, (res) => {
            //if the response shows access enabled as false, go to home page and show alert
            if (!res.content.accessEnabled) {
              setShowAlert(true);
            } else {
              setShowAlert(false);

              if (
                getAllAPI &&
                getAllAPI.data &&
                getAllAPI.data.content &&
                getAllAPI.data.content[0]
              ) {
                fetchTimeStamp();
              }
              showHeader();
            }
          })
        );
      }
    }

    //if isTestingActive is false, it is open for all users
    else {
      setShowAlert(false);

      if (
        getAllAPI &&
        getAllAPI.data &&
        getAllAPI.data.content &&
        getAllAPI.data.content[0]
      ) {
        fetchTimeStamp();
      }
      showHeader();
    }
  }, [getAllAPI]);

  useEffect(() => {
    dispatch(unsetRun());
  }, []);

  return showAlert === null ? (
    <Spinner />
  ) : showAlert ? (
    <CustomLandingBody showAlert={showAlert} dashboardName={dashboardName} />
  ) : (
    <div>
      <ActivationSalesView
        salesData={salesData}
        timestampArr={timestampArr}
        dashboardName={dashboardName}
        partnerRoleType={partnerRoleType}
      />
    </div>
  );
};

export default ActivationSales;
